import { resetMovetoStore } from '../actions/resetMoveToStore';
import { getStore, initialStore } from '../store/store';
import { mutator } from 'satcheljs';

// reset moveTo mailbox store to its initial value
mutator(resetMovetoStore, () => {
    let moveToStore = getStore();
    Object.keys(moveToStore).forEach(prop => {
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS7053 (12,9): Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'MoveToFolderMenuStore'.
        // @ts-expect-error
        moveToStore[prop] = initialStore[prop];
    });
});
